import { TApplicationState } from '../../types/redux';

export const selectIsAnimationAvailable = (state: TApplicationState) => state.pageState.animationAvailable;
